import { exchangeKioskAuthCode, extractKioskSession, normalizeLoginUser } from '@/api'
import { getApiData, getApiErrorMessage, isApiSuccess } from '@/lib/api-response'
import { setAuthMode, setAuthSessionItem, setStoredUser } from '@/lib/auth-storage'
import { setParkingOsSession } from '@/lib/parking-session'
import type { KioskLoginResult } from '@/types/auth'

export async function consumeAuthCodeFromSearch(search: string): Promise<{ ok: boolean; message?: string }> {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const authCode = params.get('authCode')?.trim()
  if (!authCode) return { ok: true }

  const payload = await exchangeKioskAuthCode(authCode)
  if (!isApiSuccess(payload)) {
    return { ok: false, message: getApiErrorMessage(payload, '授权码兑换失败') }
  }
  const data = getApiData<KioskLoginResult>(payload)
  const session = extractKioskSession(data)
  if (!session.token || !session.parkingId) {
    return { ok: false, message: '授权码兑换成功但缺少车场会话' }
  }
  setAuthSessionItem('accessToken', session.token)
  setAuthMode('platform')
  if (data) setStoredUser(normalizeLoginUser(data))
  setParkingOsSession({
    parkingId: session.parkingId,
    parkName: session.parkName,
    token: session.token,
  })
  return { ok: true }
}
